const CONFIG_MODE_ORG_ID_PARAM = 'orgId'
const LANGUAGE_QUERY_PARAM = 'language'

const toSupportedLocale = (language: string | undefined | null): string => {
  const base = language?.split('-')[0]?.toLowerCase()

  return base === 'en' || base === 'de' ? base : 'de'
}

export const getBootstrapAcceptLanguage = (): string => {
  const searchParams = new URLSearchParams(window.location.search)
  const isConfigMode = Boolean(searchParams.get(CONFIG_MODE_ORG_ID_PARAM))

  if (isConfigMode) {
    return toSupportedLocale(searchParams.get(LANGUAGE_QUERY_PARAM))
  }

  return toSupportedLocale(window.localStorage.getItem('i18nextLng'))
}

export const getBrowserTimeZone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Berlin'
  } catch {
    return 'Europe/Berlin'
  }
}

export const getPublicConfigRequestHeaders = (): Record<string, string> => ({
  Accept: 'application/json',
  'Accept-Language': getBootstrapAcceptLanguage(),
  'x-time-zone': getBrowserTimeZone()
})
